import { IconButton, Tooltip } from '@mui/material';
import { Icon } from '../../Atoms/Icon';

export interface HideRecordButtonProps {
  hidden: boolean;
  onClick: () => void;
  testId: string;
  // How the hide tooltip names the record in Salesforce: Asset, Project, Quote.
  sfRecordLabel?: string;
}

const UNHIDE_TOOLTIP = 'Select to unhide record and view in the portal.';

export const HideRecordButton = ({ hidden, onClick, testId, sfRecordLabel = 'record' }: HideRecordButtonProps) => (
  <Tooltip
    title={
      hidden
        ? UNHIDE_TOOLTIP
        : `Select to hide record from view in the portal. The ${sfRecordLabel} in SF will not be impacted.`
    }
    placement="top">
    <IconButton
      className={`self-center ${hidden ? '!bg-secondary-300' : '!bg-main-200'} hover:!bg-secondary-200 !rounded-lg h-7 w-9`}
      aria-label={hidden ? 'Unhide record' : 'Hide record'}
      data-testid={testId}
      onClick={onClick}>
      <Icon
        className="p-2"
        type={hidden ? 'eyeClosed' : 'eyeOpen'}
      />
    </IconButton>
  </Tooltip>
);
